var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { class: _vm.spinnerClass },
      [
        _c("vue-simple-spinner", {
          attrs: {
            size: _vm.size,
            "text-fg-color": _vm.textFgColor,
            "font-size": _vm.fontSize,
            spacing: _vm.spacing,
            speed: _vm.speed,
            "line-size": _vm.lineSize,
            "line-fg-color": _vm.lineFgColor,
            "line-bg-color": _vm.lineBgColor,
            message: _vm.message,
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { class: _vm.slotClass }, [_vm._t("default")], 2),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }